import { createContext } from 'react';
import type { CellContext, ColumnDef } from '@/lib/tanstack-table';
import type { AssignmentLine } from 'src/api/rpc/hooks/procurement/useReplenishmentSuggestions';
import {
  DEPENDENT_USAGE_COLUMN_ID,
  USAGE_12_COLUMN_ID,
} from '../utils/buyerBoardColumns';
import type { NeedGroup } from '../utils/needRows';

export interface NeedRowsValue {
  needs: ReadonlyMap<string, NeedGroup>;
  needOf: ReadonlyMap<string, string>;
  isExpanded: (needId: string) => boolean;
  toggle: (needId: string) => void;
}

/** The board's need rows (GEN-2938); absent on a table that has none. */
export const NeedRowsContext = createContext<NeedRowsValue | null>(null);

/**
 * Item-level columns: the need row shows them once, so its SO rows leave them
 * empty and the only ink under a need is what differs between orders. Usage
 * is per item and location, and its hover must stay reachable on the need row
 * (GEN-3165), so it renders from a real line, not read-only.
 */
export const ITEM_COLUMN_IDS: ReadonlySet<string> = new Set([
  'warehouse',
  'pop',
  'stock',
  'buyer',
  'trigger',
  'salesOrder',
  USAGE_12_COLUMN_ID,
  DEPENDENT_USAGE_COLUMN_ID,
]);

export type LineCell = NonNullable<ColumnDef<AssignmentLine>['cell']>;
export type LineCellContext = CellContext<AssignmentLine, unknown>;
